'use client';
import {ExternalLink} from 'common/components/external-link';
import {Panel} from 'common/components/panel';
import {useTranslation} from 'react-i18next';

export const SvInfoPanel = ({link}: {link: string}) => {
  const {t} = useTranslation('motorvogn');
  return (
    <Panel id='more-info' variant='warning' heading={t('motorvogn:sv-more-info.heading')}>
      {t('motorvogn:sv-more-info.pre-link')}
      <ExternalLink href={link}>{t('motorvogn:sv-more-info.link')}</ExternalLink>
    </Panel>
  );
};
